module.exports = __webpack_public_path__ + "img/Yoshna Gude, Director of Finance, Schulich Finance Association .f9f4135c.webp";